import React, { useState, useEffect } from 'react';

const DEFAULT_FALLBACK_IMAGE =
  'https://images.unsplash.com/photo-1584992236310-6edddc08acff?auto=format&fit=crop&w=800&q=80';

export default function FramedImage({
  src,
  alt = '',
  className = '',
  imgClassName = '',
  containerStyle = {},
  imgStyle = {},
  fallbackSrc = DEFAULT_FALLBACK_IMAGE,
  loading = 'lazy',
  decoding = 'async',
  onClick,
  ...props
}) {
  const [currentSrc, setCurrentSrc] = useState(src || fallbackSrc);

  useEffect(() => {
    setCurrentSrc(src || fallbackSrc);
  }, [src, fallbackSrc]);

  const handleError = () => {
    if (currentSrc !== fallbackSrc) {
      setCurrentSrc(fallbackSrc);
    }
  };

  return (
    <div
      className={`framed-image-container ${className}`}
      style={containerStyle}
      onClick={onClick}
      {...props}
    >
      <img
        src={currentSrc}
        alt=""
        aria-hidden="true"
        className="framed-image-bg"
        loading="lazy"
        onError={handleError}
      />
      <img
        src={currentSrc}
        alt={alt}
        className={`framed-image-fg ${imgClassName}`}
        loading={loading}
        decoding={decoding}
        style={imgStyle}
        onError={handleError}
      />
    </div>
  );
}
